export { SocialProofContainer as default } from './SocialProofContainer';
